import BarProgressDefault from '../../lib/jin/svgchartlib/01_Charts/05_Bar_Progress/includes/primitives/Data'

export default BarProgressDefault